<template>
  <section
      :id="!!id.length ? id : null"
      class="our-values push-v--mobile--small push-v--tablet--small push-v--desktop--xx-large"
  >
    <h2
        v-if="title"
        data-entrance="fade"
        class="text-center our-values__title push-v--mobile--medium push-v--tablet--medium"
    >
      {{ title }}
    </h2>
    <div class="our-values__block row justify-content-lg-around">
      <div
          v-for="(item, index) in items"
          :key="index"
          :data-entrance-delay="getDelay(index)"
          data-entrance="fade-in-down-small"
          class="col-10 offset-1 col-lg-4 offset-lg-0 push-v--mobile--small push-v--tablet--medium"
      >
        <our-values-card v-bind="item" :shape="getShape(index)" data-entrance="fade-in-down-small" />
      </div>
    </div>
  </section>
</template>

<script>
import getStatic from '~/utils/get-static';
import OurValuesCard from '~/components/components/OurValuesCard.vue';

export default {
  components: {
    OurValuesCard,
  },
  props: {
    id: { type: String, default: '' },
    title: { type: String, default: 'Our Values' },
    items: {
      type: Array,
      default() {
        return [
          {
            title: 'Serviced Living',
            body:
              '<p>Quality, modern and serviced apartments, studios and rooms in some of London\'s most iconic locations, our serviced living buildings combine the best of both worlds. With beautifully furnished private rooms, as well as access to communal spaces, our houses provide a unique sense of community and luxury in some of London\'s hotspots.</p>',
            image: {
              url: getStatic('/images/content/our-values/our-values-01.jpg'),
              description: '',
            },
            callToActionText: 'Visit Site',
            externalLink: '',
            link: {
              slug: '/about',
            },
          },
          {
            title: 'Serviced Living',
            body:
              '<p>Quality, modern and serviced apartments, studios and rooms in some of London\'s most iconic locations, our serviced living buildings combine the best of both worlds. With beautifully furnished private rooms, as well as access to communal spaces, our houses provide a unique sense of community and luxury in some of London\'s hotspots.</p>',
            image: {
              url: getStatic('/images/content/our-values/our-values-02.jpg'),
              description: '',
            },
            callToActionText: '',
            externalLink: '',
            link: {
              slug: '/about',
            },
          },
          {
            title: 'Serviced Living',
            body:
              '<p>Quality, modern and serviced apartments, studios and rooms in some of London\'s most iconic locations, our serviced living buildings combine the best of both worlds. With beautifully furnished private rooms, as well as access to communal spaces, our houses provide a unique sense of community and luxury in some of London\'s hotspots.</p>',
            image: {
              url: getStatic('/images/content/our-values/our-values-03.jpg'),
              description: '',
            },
            callToActionText: '',
            externalLink: '',
            link: {
              slug: '/about',
            },
          },
        ];
      },
    },
  },
  mounted() {
    const _this = this;
    this.equalHeights();

    function debounce(func) {
      let timer;
      return function(event) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(func, 500, event);
      };
    }

    window.addEventListener('resize', debounce(function(e) {
      _this.equalHeights();
    }));
  },
  methods: {
    getShape(index) {
      switch (index % 3) {
        case 0:
          return 'OurValuesShapeOne';
        case 1:
          return 'OurValuesShapeTwo';
        case 2:
          return 'OurValuesShapeThree';
        default: {
          return 'OurValuesShapeOne';
        }
      }
    },
    getDelay(index) {
      switch (index % 3) {
        case 0:
          return '50';
        case 1:
          return '400';
        case 2:
          return '600';
        default: {
          return '50';
        }
      }
    },
    equalHeights() {
      const findClass = document.querySelectorAll('.our-values-card__body');
      let tallest = 0;

      for (let i = 0; i < findClass.length; i++) {
        const ele = findClass[i];
        ele.style.height = 'auto';
      }
      for (let i = 0; i < findClass.length; i++) {
        const ele = findClass[i];
        const eleHeight = ele.offsetHeight;

        tallest = (eleHeight>tallest ? eleHeight : tallest); /* look up ternary operator if you dont know what this is */
      }
      for (let i = 0; i < findClass.length; i++) {
        const ele = findClass[i];
        ele.style.height = tallest + 'px';
      }
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/modules/_our-values.scss';
</style>
